
import OrderBoxBuyer from '@/components/OrderBox/OrderBoxBuyer'
import UserInfoBox from '@/components/UserInfoBox'

export default {
    components: {
        OrderBoxBuyer,
        UserInfoBox
    }
}
